module.exports = __webpack_public_path__ + "static/viread-illustrations-1-d87752335d60cca6497f2f654f42f622.jpg";